const trainManagement = {
    bindings: {
        train: '<',
        topology: '<',
        descriptors: '<',
        syncStatus: '<',
        topologyUpdatedTime: '<',
        isTrainConnected: '<',
    },
    templateUrl: '/modules/configurationManagement/train-management/train-management.html',
    controller: 'TrainManagementController',
};

angular
    .module('configuration-management.module')
    .component('trainManagement', trainManagement)
    .config(function ($stateProvider) {
        $stateProvider.state('train.management', {
            url: '/management/car/:carNumber',
            views: {
                'traintab@train': 'trainManagement',
            },
            resolve: {
                topology: (MTService, $transition$) => MTService.getTopology($transition$.params().consist),
                descriptors: PackageService => PackageService.getAllDescriptors(),
                auth: function (userService, $state, eventService) {
                    return userService
                        .resolve(['ACCESS_TRAIN_MANAGEMENT'])
                        .then(() => {
                        })
                        .catch(() => {
                            eventService.trigger('userservice:unauthorized');
                            $state.go('train');
                        });
                },
            },
        });
    });
